export const CASHBACK_STATUS_COLOR = {
  AVAILABLE: "info",
  PENDING: "warning",
  REDEEMED: "success",
};

export const CASHBACK_STATUS_COLOR_INFO = {
  NON_DELIVERED: "Order not delivered yet. Check back later.",
  COOLDOWN: "Will be processed soon.",
  APPROVAL: "Pending approval. You can track your order here.",
  BALANCEDUE: "This order has a pending payment, please clear the dues with the restaurant.",
};

export const RESTAURANT_LEVEL_HEX_COLOR = {
  "Level 1": "rgba(0, 0, 0, 0.65)",
  "Level 2": "#1B84FF",
  "Level 3": "#7239EA",
};

export const RESTAURANT_LEVEL = [
  { label: "LEVEL 1", value: "LEVEL 1" },
  { label: "LEVEL 2", value: "LEVEL 2" },
  { label: "LEVEL 3", value: "LEVEL 3" },
];
export const CASHBACK_STATUS = [
  { label: "AVAILABLE", value: "AVAILABLE" },
  { label: "PENDING", value: "PENDING" },
  { label: "REDEEMED", value: "REDEEMED" },
];

export const POINTS_EARNED = [
  { label: "0 to 500 ", value: { lv: "0", hv: "500" } },
  { label: "500 to 1500 ", value: { lv: "500", hv: "1500" } },
  { label: "1500 to 3000 ", value: { lv: "1500", hv: "3000" } },
  { label: "3000 to 5000 ", value: { lv: "3000", hv: "5000" } },
  { label: "5000+", value: { lv: "5000", hv: "" } },
];

export const ADDITIONAL_POINTS_BADGES = {
  PROCESSED: "info",
  PENDING: "warning",
  REDEEMED: "success",
};

export const CONVERSION_POINTS = 100;
